export default __webpack_public_path__ + "static/media/ellipse_advantages.7a33a50d.svg";